import axiosClient from "./axiosClient";

export const listarBancos = () => axiosClient.get("/bancos").then((r) => r.data);
export const upsertBanco = (data) => axiosClient.post("/bancos", data).then((r) => r.data);
export const eliminarBanco = (id) => axiosClient.delete(`/bancos/${id}`);
